export default "__VITE_ASSET__CeR8m6Y___"